import { IFetchLeadsByParametersProtocol, IFetchLeadsByParametersProtocolRequest, IFetchLeadsByParametersProtocolResponse } from "../../protocols/leads/IFetchLeadsByParametersProtocol";
import { ILeadsRepository } from "../../repositories/ILeadsRepository";

export class FetchLeadsByParametersUseCase implements IFetchLeadsByParametersProtocol {
  constructor(private leadsRepository: ILeadsRepository){}
  async execute({limit, orderBy, orderType, page, email, name, phone, originName, originStatus, originType}: IFetchLeadsByParametersProtocolRequest): Promise<IFetchLeadsByParametersProtocolResponse> {
    const currentPageValidated = page > 0 ? page: 1
    const limitValidated = limit <= 100 && limit > 0 ? limit : 100
    const {dataCount, leadsDetails} = await this.leadsRepository.findManyByParameters({
      page: currentPageValidated, 
      orderType, 
      orderBy,
      limit: limitValidated
    }, email, name, phone, originName, originStatus, originType)

    const totalPages = Math.ceil(dataCount / limitValidated)
    const nextPage = currentPageValidated < totalPages ? currentPageValidated + 1 : null;

    return {
      leads: leadsDetails,
      previousPage: currentPageValidated - 1,
      currentPage: currentPageValidated,
      nextPage,
      totalPages,
      totalData: dataCount,
      perPage: limit
    }
  }
}